import {useEffect, useRef} from 'react'
import {useFormikContext} from 'formik'
import {IReservationModel} from './ReservationModel'

const FormWatcher = () => {
  const {values, setFieldValue} = useFormikContext<IReservationModel>()
  const prev = useRef<IReservationModel>(values)

  const isEmpty = (g: any | null | undefined): boolean => !g || !g.id || g.id === ''
 
  useEffect(() => {
    const prevValues = prev.current

    const vg = values.vehicleGroup
    const vg1 = values.vehicleGroup1
    const pvg = prevValues.vehicleGroup
    const pvg1 = prevValues.vehicleGroup1

    // 1) vehicleGroup SİLİNDİ → diğerlerini de sil
    if (isEmpty(vg) && !isEmpty(pvg)) {
      setFieldValue('vehicleGroup1', {id: '', groupName: ''})
      setFieldValue('deliveredVehicleGroup', {id: '', groupName: ''})
      setFieldValue('vehicleGroupId', '')
      setFieldValue('vehicleGroupId1', '')
      setFieldValue('deliveredVehicleGroupId', '')
      setFieldValue('givenGroup', '')
      setFieldValue('vehicleGroupName', '')
      setFieldValue('vehicleGroupAdd', '') 
    }

    // 2) vehicleGroup1 SİLİNDİ → diğerlerini de sil
    if (isEmpty(vg1) && !isEmpty(pvg1)) {
      setFieldValue('vehicleGroup', {id: '', groupName: ''})
      setFieldValue('deliveredVehicleGroup', {id: '', groupName: ''})
      setFieldValue('vehicleGroupId', '')
      setFieldValue('vehicleGroupId1', '')
      setFieldValue('deliveredVehicleGroupId', '')
      setFieldValue('givenGroup', '')
      setFieldValue('vehicleGroupName', '')
      setFieldValue('vehicleGroupAdd', '')
    }

    // 3) vehicleGroup değişti → vehicleGroup1 ve deliveredVehicleGroup güncelle
    if (!isEmpty(vg) && JSON.stringify(vg) !== JSON.stringify(pvg)) {
      setFieldValue('vehicleGroup1', vg)
      setFieldValue('deliveredVehicleGroup', vg)
      setFieldValue('vehicleGroupId', vg?.id)
      setFieldValue('vehicleGroupId1', vg?.id)
      setFieldValue('deliveredVehicleGroupId', vg?.id)
      setFieldValue('givenGroup', vg?.groupName)
      setFieldValue('vehicleGroupName', vg?.groupName)
      setFieldValue('vehicleGroupAdd', vg?.groupName)
    }

    // 4) vehicleGroup1 değişti → vehicleGroup ve deliveredVehicleGroup güncelle
    if (!isEmpty(vg1) && JSON.stringify(vg1) !== JSON.stringify(pvg1)) {
      setFieldValue('vehicleGroup', vg1)
      setFieldValue('deliveredVehicleGroup', vg1)
      setFieldValue('vehicleGroupId', vg1?.id)
      setFieldValue('vehicleGroupId1', vg1?.id)
      setFieldValue('deliveredVehicleGroupId', vg1?.id)
      setFieldValue('givenGroup', vg1?.groupName)
      setFieldValue('vehicleGroupName', vg1?.groupName)
      setFieldValue('vehicleGroupAdd', vg1?.groupName)
    }
    prev.current = values
  }, [values.vehicleGroup, values.vehicleGroup1, setFieldValue, values])

  return null // UI yok, sadece Formik'i izliyor
}

export default FormWatcher
